/* Una tendina chiusa deve essere chiusa anche per chi non la vede.
 *
 * IL DIFETTO, MISURATO
 * snippets/perla-desc-tabs.liquid rende sei tendine sulla scheda prodotto
 * (descrizione, dettagli, personalizzazione, taglie, cura, spedizione) e
 * sections/faq.liquid ne rende una per domanda. Il pannello chiuso e'
 * chiuso SOLO A VEDERSI: assets/base.css:580 fa
 *
 *     .accordion__panel { overflow: hidden; max-height: 0; transition: ... }
 *
 * e max-height:0 non toglie niente dall'albero di accessibilita'. Quindi un
 * lettore di schermo legge tutti e sei i pannelli di fila -- descrizione,
 * dettagli, taglie, cura e spedizione una dietro l'altra, come se fossero
 * testo normale -- e il Tab entra nei link che ci stanno dentro, mettendo a
 * fuoco cose che sullo schermo sono alte zero pixel. Chi naviga con la
 * tastiera mette a fuoco il nulla; chi ascolta la pagina si sente leggere la
 * scheda intera senza capire che erano sezioni richiudibili.
 *
 * PERCHE' STA IN UN FILE A PARTE E NON IN global.js
 * Il gestore del clic delle tendine sta in assets/global.js, che e' un
 * bundle MINIFICATO: 2 righe per 89.217 byte, e il sorgente leggibile non
 * esiste (misurato -- il file in git viene dall'Admin API, cioe' e' la copia
 * conservata, ed e' cosi'). Modificarlo vuol dire un diff che nessuno puo'
 * rivedere, su un file dove un carattere sbagliato spegne tutto il
 * JavaScript del negozio, carrello compreso. E' la stessa scelta, con la
 * stessa ragione, di assets/perla-fuoco.js e assets/perla-studio-ui.js: non
 * si tocca il minificato, gli si mette accanto qualcosa che si legge. Se
 * questo file sparisse, le tendine tornerebbero esattamente come sono oggi.
 *
 * L'ORDINE E' LA PARTE DELICATA, E SE SI SBAGLIA LE TENDINE NON SI APRONO
 * global.js apre il pannello scrivendogli una max-height pari alla sua
 * altezza vera. Un pannello con `hidden` e' display:none, e un elemento
 * display:none ha altezza ZERO: se `hidden` fosse ancora addosso nel momento
 * in cui global.js misura, la tendina si aprirebbe a zero e resterebbe
 * chiusa per tutti, vedenti compresi. Quindi:
 *
 *   - in APERTURA `hidden` si toglie in fase di CATTURA, cioe' prima che il
 *     gestore di global.js (in fase di risalita) misuri;
 *   - in CHIUSURA si rimette solo a transizione finita, altrimenti il
 *     pannello sparirebbe di scatto e l'animazione di chiusura non si
 *     vedrebbe piu'.
 *
 * E lo stato non lo decidiamo noi: si legge da aria-expanded, che e' quello
 * che global.js scrive. Cosi' se domani cambia il modo di aprire, questo
 * file continua a seguirlo invece di contraddirlo.
 */
(function () {
  'use strict';

  // .4s in base.css:580; il margine copre un rendering lento
  var CHIUSURA_MS = 600;
  var contatore = 0;

  function pannelloDi(innesco) {
    // la struttura e' <div.accordion__item><button><div.accordion__panel>
    var p = innesco.nextElementSibling;
    while (p && !/(^|\s)accordion__panel(\s|$)/.test(p.className || '')) {
      p = p.nextElementSibling;
    }
    return p;
  }

  function aperta(innesco) {
    return innesco.getAttribute('aria-expanded') === 'true';
  }

  function mostra(pannello) {
    if (pannello.hasAttribute('hidden')) pannello.removeAttribute('hidden');
  }

  function nascondiQuandoFinisce(innesco, pannello) {
    var fatto = false;
    function chiudi() {
      if (fatto) return;
      fatto = true;
      pannello.removeEventListener('transitionend', alTermine);
      // rileggere lo stato: nel frattempo il cliente puo' averla riaperta
      if (!aperta(innesco)) pannello.setAttribute('hidden', '');
    }
    function alTermine(e) {
      if (e.target === pannello && e.propertyName === 'max-height') chiudi();
    }
    pannello.addEventListener('transitionend', alTermine);
    // ripiego: se la transizione non parte (animazioni ridotte, o il
    // browser non la lancia perche' il valore non cambia) transitionend non
    // arriva mai, e senza questo il pannello resterebbe leggibile per
    // sempre -- cioe' il difetto, di nuovo.
    setTimeout(chiudi, CHIUSURA_MS);
  }

  function prepara(radice) {
    var inneschi = (radice || document).querySelectorAll('.accordion__trigger');
    Array.prototype.forEach.call(inneschi, function (innesco) {
      if (innesco.__tendinaLegata) return;
      var pannello = pannelloDi(innesco);
      if (!pannello) return;
      innesco.__tendinaLegata = true;

      // il legame fra comando e cosa comandata, che prima non c'era
      if (!pannello.id) {
        contatore += 1;
        pannello.id = 'tendina-' + contatore;
      }
      if (!innesco.getAttribute('aria-controls')) {
        innesco.setAttribute('aria-controls', pannello.id);
      }
      if (!innesco.hasAttribute('aria-expanded')) {
        innesco.setAttribute('aria-expanded', 'false');
      }

      // lo stato di partenza: la prima domanda della FAQ nasce aperta
      if (aperta(innesco)) mostra(pannello);
      else pannello.setAttribute('hidden', '');

      // aria-expanded e' la verita', e la scrive global.js
      if (typeof window.MutationObserver === 'function') {
        new window.MutationObserver(function () {
          if (aperta(innesco)) mostra(pannello);
          else nascondiQuandoFinisce(innesco, pannello);
        }).observe(innesco, {
          attributes: true, attributeFilter: ['aria-expanded']
        });
      }
    });
  }

  // CATTURA: prima che global.js misuri l'altezza del pannello
  document.addEventListener('click', function (e) {
    var innesco = e.target.closest && e.target.closest('.accordion__trigger');
    if (!innesco) return;
    var pannello = pannelloDi(innesco);
    // si scopre solo se sta per APRIRSI: aria-expanded e' ancora quello di
    // prima del clic, quindi "false" vuol dire "fra un attimo si apre"
    if (pannello && !aperta(innesco)) mostra(pannello);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepara(document); });
  } else {
    prepara(document);
  }

  // le sezioni ricaricate dall'editor del tema, come fa motion.js
  document.addEventListener('shopify:section:load', function (e) {
    prepara(e.target);
  });
})();
